import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import { Box, Dialog as MuiDialog } from '@mui/material';
import { green } from '@mui/material/colors';
import { useEffect } from 'react';
import { Typography } from './Typography';

export interface SuccessDialogProps {
  open: boolean;
  title: string;
  /** Optional — pass together with autoDismissMs to have the dialog close itself. */
  onDismiss?: () => void;
  /** Optional — omit when the caller controls `open` externally (e.g. its own timer). */
  autoDismissMs?: number;
}

export const SuccessDialog = ({
  open,
  title,
  onDismiss,
  autoDismissMs,
}: SuccessDialogProps) => {
  useEffect(() => {
    if (!open || !autoDismissMs || !onDismiss) return;
    const timer = setTimeout(onDismiss, autoDismissMs);
    return () => clearTimeout(timer);
  }, [open, autoDismissMs, onDismiss]);

  return (
    <MuiDialog
      open={open}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'grey.300',
            opacity: 1,
          },
        },
        paper: {
          sx: {
            borderRadius: '24px',
            width: '360px',
            overflow: 'hidden',
          },
        },
      }}
    >
      <Box
        data-testid="success-dialog"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '80px',
          gap: '32px',
        }}
      >
        <Box
          sx={{
            width: '80px',
            height: '80px',
            borderRadius: '200px',
            backgroundColor: green[100],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CheckCircleOutlined sx={{ fontSize: '48px', color: 'success.dark' }} />
        </Box>
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 700,
            lineHeight: 1.6,
            letterSpacing: '0.15px',
            color: 'text.primary',
            whiteSpace: 'nowrap',
            textAlign: 'center',
          }}
        >
          {title}
        </Typography>
      </Box>
    </MuiDialog>
  );
};
